import { BlurbCard } from 'ui/components';

export const BlurbCardFeature: React.FC<Umbraco.BlurbCard> = ({ content, settings }) => <BlurbCard {...content?.properties} settings={settings} />;
